import { handleUploadShipmentDoc } from 'api/fetchers';
import axios from 'axios';
import React, { useState } from 'react'
import { useMutation } from 'react-query';
import Swal from 'sweetalert2';

const useUploadDoc = ({ shipmentId, refetch }) => {
        const [addDocs, setAddDocs] = useState(false);
        const [uploading, setUploading] = useState(false);
        const [file, setFile] = useState();
        const [fileData, setFileData] = useState();
        const { mutateAsync: uploadDocFunc } = useMutation({
        mutationFn: ({ link, name, originalFilename }) =>
            handleUploadShipmentDoc({ link, name, originalFilename, shipmentId }),
        mutationKey: [shipmentId, "upload-document"],
        onSuccess: (data) => {
            if (data) {
                refetch?.();
                Swal.fire({
                    title: "Success",
                    text: data?.data?.message || data?.message || "File updated successfully",
                    icon: "success",
                    confirmButtonText: "OK",
                    width: "280px",
                    confirmButtonColor: "rgb(111, 0, 255)",
                });
                setAddDocs(false);
            } else {
                Swal.fire({
                    title: "Error",
                    text: data?.data?.message,
                    icon: "error",
                    confirmButtonText: "Close",
                    width: "280px",
                    confirmButtonColor: "crimson",
                });
            }
        },
    });

        const handleFileRemove = (inputId) => {
            setFileData((prevFiles) => ({
                ...prevFiles,
                [inputId]: null,
            }));
        };

    const handleUpload = async (selectedFile, userGivenName, fileId) => {
        setUploading(true);
        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            const response = await axios.post("/v1/utility/upload-file", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data?.link) {
                const url = response?.data?.link;
                if (fileId) { 
                      setFileData((prevFiles) => ({
                          ...prevFiles,
                          [fileId]: {
                              name: userGivenName,
                              url: url,
                              file: selectedFile,
                          },
                      }));
                }
                setFile({
                    name: userGivenName,
                    url: url,
                    file: selectedFile,
                });
                uploadDocFunc({
                    link: url,
                    name: userGivenName,
                    originalFilename: selectedFile?.name,
                });
            } else {
                console.error("Upload failed: No file URL returned.");
            }
        } catch (error) {
            console.error("Upload error:", error);
        } finally {
            setUploading(false);
        }
    };
    return {
        handleUpload,
        addDocs,
        file,
        setFile,
        uploading,
        setUploading,
        setAddDocs,
        uploadDocFunc,
        handleFileRemove,
        fileData,
    };
};

export default useUploadDoc